export default __webpack_public_path__ + "static/media/logo_small_green.aa947bde.png";